import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import ImgView from 'components/common/FileController/ImgView';
import { Card, Button } from 'antd';

@inject('orderStore')
@observer
class GoodsList extends Component {

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log(nextProps.selectUser);
    if (nextProps.selectUser !== this.props.selectUser) {
      if (nextProps.selectUser !== null) {
        this.props.orderStore.orderGoodsList(nextProps.selectUser.userId, nextProps.selectUser.userJobCd);
      } else {
        this.props.orderStore.orderGoodsList('', '');
      }
    }
  }

  render() {
    const { goodsList, valCondition } = this.props.orderStore;
    const { onSelect, selectUser, detailGoods } = this.props;
    const ordGoodCnt = (data) => {
      let gjGdCnt = 99999999999999;
      if (selectUser !== null && selectUser.ordGoodList !== undefined && selectUser.ordGoodList !== null) {
        selectUser.ordGoodList.map((item)=>{ return(
          (item.pGdCd === data.pGdCd) && (gjGdCnt = parseInt(item.gjGdCnt))
        )})
      }
      
      if (gjGdCnt > 0) {
        return(<Button type="primary" onClick={()=>onSelect({...data, gjGdCnt: gjGdCnt})} >선택</Button>);
      } else {
        if ((selectUser.userId === '00000000' || selectUser.userId === '11111111') 
          || (valCondition.exceptionYn === "Y")) {
          return(<Button type="primary" onClick={()=>onSelect(data)} >선택</Button>);
        } else {
          return(
            (gjGdCnt <= 0) &&
            <div className="no_item">
              기준수량 지급완료되어<br />주문불가합니다.
              {/* ✖를 이미지로 교체하시고 텍스트를 숨시고 싶으시면 span에 class txt_hide를 넣어주시면 됩니다.  */}
              <span className="no_img" role="img" aria-label="x">
                {/* <span className="no_img" role="img" aria-label="x"> ✖ </span> */}
                <img
                  alt={'warning'}
                  src={require('../../../img/warning.png')}
                  width={105}
                  // style={{
                  //   webkitFilter: ,
                  // }}
                />
              </span>
            </div>
          );
        }
      }
    };
          
    return (
      selectUser !== null &&
      <Fragment>
        <h2>▶ 주문가능 유니폼</h2>
        <Card>
        {/* {goodsList !== undefined && goodsList !==null && goodsList.length === 0 && 
          <h4 style={{ color: 'red' }}>주문가능 한 유니폼이 없습니다.</h4>
        } */}
        {goodsList.map((item, idx)=>{
          return (
          <Card.Grid
            key={idx}
            hoverable={false} 
            className={
              (detailGoods !== null && detailGoods.gdCd !== undefined && detailGoods.gdCd !== null
              && item.gdCd !== undefined && item.gdCd !== null && detailGoods.gdCd === item.gdCd) 
              ? "item_unip_card on" : "item_unip_card"
            }
          >
            <Card
              title={item.gdNm}
              hoverable
              /* style={{ width: 150, height: 180 }} */
              cover={
                item.gdImgUrlInfo_fileId !== undefined && item.gdImgUrlInfo_fileId !== null &&
                item.gdDetailUrlInfo_fileId !== undefined && item.gdDetailUrlInfo_fileId !== null &&
                <Fragment>
                  <ImgView
                    viewGlass={true}
                    fileInfo={{
                      fileId: item.gdImgUrlInfo_fileId,
                      fileName: item.gdImgUrlInfo_fileName,
                      physicalName: item.gdImgUrlInfo_physicalName,
                      serverSubPath: item.gdImgUrlInfo_serverSubPath,
                    }}
                    /*width={100}
                    height={100}*/
                    detailFileInfo={{
                      fileId: item.gdDetailUrlInfo_fileId,
                      fileName: item.gdDetailUrlInfo_fileName,
                      physicalName: item.gdDetailUrlInfo_physicalName,
                      serverSubPath: item.gdDetailUrlInfo_serverSubPath,
                    }}
                  />
                </Fragment>
              }
              actions={[ordGoodCnt(item)]}
            >
              {/* <Card.Meta title={item.pGdNm} description={item.gdNm} /> */}
            </Card>
          </Card.Grid>
          );
        })}
        </Card>
      </Fragment>
    );
  }

}

export default GoodsList;
